import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { translate, t } from 'react-switch-lang';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { faMobileAlt, faWindow } from '@awesome.me/kit-299dd46f46/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { event as ampEvent, event, logAmpEvent } from '../../../helperFunctions/Amplitude';
import './contactusform.scss';
import './ContactUsMaple.scss';
import { SubmitContactUs } from '../../../helperFunctions/SubmitContactUs';
import { mailcheckValidate, validateCardNumber, validateEmpty, validateEmail, validateBody, validateName } from './Validation';
import { hideContactError } from './NPPValidation';

import { setScreenReaderAlert } from '../../../helperFunctions/Accessibility';
import { performSearch, searchByIDs } from '../../../components/algolia/AlgoliaUtils';
import RelevantFAQ from './RelevantFAQ';
import RadioBuilder from './RadioBuilder';
import mapleCardExample from '../../../images/maple/CardBack.png';

function ContactUsMaple({ widgetMode, removeAccount }) {
  const { lang } = useSelector((state) => state);
  const emailRef = useRef();
  const bodyRef = useRef();
  const fullNameRef = useRef('');
  const cardNumberRef = useRef('');
  const [appId, setAppId] = useState('');
  const [application, setApplication] = useState('');

  const [webActive, setWebActive] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);

  const [validateEmailOnChange, setValidateEmailOnChange] = useState(false);
  const [validateAppIdOnChange, setValidateAppIdOnChange] = useState(false);
  const [validateDescriptionOnChange, setValidateDescriptionOnChange] = useState(false);
  const [validateFullNameOnChange, setValidateFullNameOnChange] = useState(false);
  const [validateCardNumberOnChange, setValidateCardNumberOnChange] = useState(false);

  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [disable, setDisable] = React.useState(false);

  const [showContactForm, setShowContactForm] = useState(true);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [suggestedArticleAlertRead, setSuggestedArticleAlertRead] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [showEmailConfirm, setShowEmailConfirm] = useState(false);
  const [runMailCheck, setRunMailCheck] = useState(true);
  const [invalidEmailSuggestion, setInvalidEmailSuggestion] = useState(null);

  const isMobile = (window.location.href.includes('mobileapp') ? '?mobileapp' : '');

  const defaultFieldOptions = {
    pinIssues: false,
    lostStolenDamaged: false,
    linkIssues: false,
    transactionIssues: false,
    textArea: false,
    activateCard: false,
  };
  const [showFields, setShowFields] = useState(defaultFieldOptions);
  const [category, setCategory] = useState();
  const [showExampleCard, setShowExampleCard] = useState(false);

  // null values indicate shouldn't validate on change yet
  const [formErrors, setFormErrors] = useState({
    email: null,
    appId: null,
    description: null,
    fullName: null,
    cardNumber: null,
  });
  const [hardcodedArticles, setHardcodedArticles] = useState({
    pinIssues: [],
    lostStolenDamaged: [],
    transactionIssues: [],
    activateCard: [],
  });

  useEffect(() => {
    const blockLocation = (widgetMode ? 'center' : 'start');

    if (submitted) {
      const errorField = document.querySelector('.is-invalid');
      if (errorField) {
        const group = errorField.closest('.form-groups');
        if (group) {
          group.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          const input = group.querySelector('input, textarea, select');
          setTimeout(() => {
            input?.focus();
          }, 250);
        } else {
          errorField.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          errorField.focus();
        }
      }
      setSubmitted(false);
    }
  });

  function handleWebMobileClick(target) {
    setValidateAppIdOnChange(true);
    hideContactError('app_error_message');

    const isWeb = target === 'Maple website';
    if (isWeb) {
      setApplication('Web');
      setAppId('Web App - Canada Post Prepaid Card');
    } else {
      setApplication('Mobile');
      setAppId('Mobile App - Canada Post Prepaid Card');
    }
    setWebActive(isWeb);
    setMobileActive(!isWeb);
  }

  const handleShowFields = (option) => {
    setValidateEmailOnChange(false);
    setValidateAppIdOnChange(false);
    setValidateDescriptionOnChange(false);
    setValidateCardNumberOnChange(false);
    setValidateFullNameOnChange(false);

    hideContactError('category_error_message');

    switch (option) {
      case 'purchaseCard':
        setShowFields({
          ...defaultFieldOptions,
          textArea: true,
        });
        setCategory('Purchasing a card');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_PurchaseCard')));
        break;

      case 'activateCard':
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          activateCard: true,
        });
        setCategory('Activating your card');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_ActivateCard')));
        break;

      case 'pinIssues':
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          pinIssues: true,
        });
        setCategory('Card PIN issues');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_PINIssues')));
        break;
      case 'lostStolenDamaged':
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          lostStolenDamaged: true,
        });
        setCategory('Lost, Stolen, or Damaged Card');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_LostStolenDamaged')));
        break;
      case 'linkIssues':
        setShowFields({
          ...defaultFieldOptions,
          linkIssues: true,
          textArea: true,
        });
        setCategory('Link card issues');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_LinkIssues')));
        break;
      case 'reloadIssues':
        setShowFields({
          ...defaultFieldOptions,
          textArea: true,
          linkIssues: true,
        });
        setCategory('Reload Issues');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_ReloadIssues')));
        break;
      case 'useCard':
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          transactionIssues: true,
        });
        setCategory('Using a card');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_Maple_UseCard')));
        break;
      case 'accountDeletion':
        setShowFields({
          ...defaultFieldOptions,
          textArea: true,
          linkIssues: true,
        });
        setCategory('Data or account deletion request');
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_All_AccountDeletion')));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    async function fetchArticles() {
      const pinIssues = await searchByIDs(['949', '951', '2727']);
      const lostStolenDamaged = await searchByIDs(['1011']);
      const activateCard = await searchByIDs(['2729']);

      // transactionIssues go to sections, so they are hardcoded
      const transactionIssues = [
        {
          Content: [
            { Title: t('ContactForm_Maple_TransactionIssues_CardPurchases_Section'), Language: lang },
          ],
          objectID: '837',
          IsSection: true,
        },
        {
          Content: [
            { Title: t('ContactForm_Maple_TransactionIssues_DisputingTransactions_Section'), Language: lang },
          ],
          objectID: '841',
          IsSection: true,
        },
      ];

      setHardcodedArticles({ pinIssues, lostStolenDamaged, activateCard, transactionIssues });
    }

    fetchArticles();
  }, [lang]);

  // Check if widget
  useEffect(() => {
    if (widgetMode) {
      document.getElementById('desktop-contact-us').style.padding = '0px';
    }
    if (removeAccount) {
      handleWebMobileClick('Maple mobile app');
      handleShowFields('accountDeletion');
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    async function updateSearchResults() {
      const results = await performSearch(searchTerm, 'canadapost-prepaid', lang);
      if (results.length > 0) {
        setSuggestedArticleAlertRead(true);
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_Suggested_Article', null, lang));
      } else if (suggestedArticleAlertRead) {
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_No_Suggested_Article', null, lang));
      }
      setSearchResults(results);
    }
    const timer = setTimeout(updateSearchResults, 700);
    return () => { clearTimeout(timer); };
  }, [searchTerm, lang]);

  // use force param to skip onChange flags
  function validateFormFields(force) {
    const errors = {
      email: null,
      appId: null,
      description: null,
      fullName: null,
      cardNumber: null,
    };
    if ((validateEmailOnChange || force) && emailRef.current) {
      const { value } = emailRef.current;
      errors.email = validateEmpty(value) || validateEmail(value);

      if (errors.email === null) {
        setInvalidEmailSuggestion(mailcheckValidate(value));
        if (runMailCheck && invalidEmailSuggestion !== null) {
          setShowEmailConfirm(true);
          errors.email = t('Contact_EmailSuggestion').replace('xEmail', invalidEmailSuggestion);
        } else {
          setShowEmailConfirm(false);
        }
      } else {
        setShowEmailConfirm(false);
      }
    }
    if ((validateAppIdOnChange || force) && appId === '') errors.appId = t('Validation_Required');
    if ((validateDescriptionOnChange || force) && bodyRef.current) {
      const { value } = bodyRef.current;
      errors.description = validateBody(value);
    }
    if ((validateFullNameOnChange || force) && fullNameRef.current) {
      const { value } = fullNameRef.current;
      errors.fullName = validateName(value);
    }
    if ((validateCardNumberOnChange || force) && cardNumberRef.current) {
      const { value } = cardNumberRef.current;
      errors.cardNumber = validateCardNumber(value);
    }
    setFormErrors(errors);
    return errors;
  }

  useEffect(() => {
    validateFormFields();
  }, [
    lang,
    appId,
    validateEmailOnChange,
    validateAppIdOnChange,
    validateDescriptionOnChange,
    validateFullNameOnChange,
    validateCardNumberOnChange,
  ]);

  function sendAPI() {
    const data = {
      Brand: 'Maple',
      Application: application,
      BrandID: appId,
      CustomerEmail: emailRef.current.value,
      Language: lang,
      Category: category,
      Body: bodyRef.current.value,
    };

    if (fullNameRef.current) {
      data.Name = fullNameRef?.current.value;
    }

    if (cardNumberRef.current) {
      data.CardProxy = cardNumberRef?.current.value;
    }

    let sending = document.getElementById('submit-button');
    sending.innerHTML = t('ContactForm_Submitting');
    setDisable(true);

    SubmitContactUs(data).then(
      () => {
        setShow(false);
        setShowContactForm(false);
        setShowSuccessMessage(true);
        const focus = document.getElementById('mapleSuccessMessage');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      () => {
        setError(t('Error_Something_Went_Wrong'));
        setShow(true);
        sending = document.getElementById('submit-button');
        sending.innerHTML = t('ContactForm_Submit_button');
        setDisable(false);
        const focus = document.getElementById('error_message');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    );
  }

  function handleSubmit(e) {
    e.preventDefault();
    logAmpEvent(event.USER_CLICKED_SUBMIT);

    setValidateEmailOnChange(true);
    setValidateAppIdOnChange(true);
    setValidateDescriptionOnChange(true);
    setValidateCardNumberOnChange(true);
    setValidateFullNameOnChange(true);
    setSubmitted(true);

    const errors = validateFormFields(true);

    if (!Object.values(errors).some((err) => err !== null)) {
      sendAPI();
      setScreenReaderAlert(t('ScreenReader_ContactForm_Success'));
    } else {
      logAmpEvent(ampEvent.USER_ERROR_CONTACT, { 'Error Type': formErrors });
      setScreenReaderAlert(t('ScreenReader_ContactForm_Error'));
    }
  }

  const handleTextareaChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      {show && (
        <Alert
          variant="danger"
          id="error_message"
          className="mt-3"
          onClose={() => {
            setShow(false);
            setError('');
          }}
          dismissible
        >
          <p style={{ marginBottom: 0 }}>{error}</p>
        </Alert>
      )}

      {showSuccessMessage && (
        <div id="mapleSuccessMessage">
          <h1>{t('ContactForm_Submitted')}</h1>
          <Link to={(widgetMode) ? `/widget/canadapost-prepaid/${lang}${isMobile}` : `/canadapost-prepaid/${lang}/categories`}>
            <Button
              className="error-go-home-btn maple-button"
            >
              {t('ReturnHome_Btn')}
            </Button>
          </Link>
        </div>
      )}

      {/* Start Form */}
      {showContactForm && (
        <div id="desktop-contact-us">
          <div id="skip-link-content">
            <h1>{t('General_Contact_Us')}</h1>
            <p
              className="contact-label-suggestion"
            >
              {t('ContactForm_Fields_Required')}
            </p>
            <Form
              noValidate
              onSubmit={handleSubmit}
            >

              <Form.Group
                className="form-groups"
                controlId="ContactForm_General_Email_"
                required
              >
                <fieldset>
                  <Form.Label as="legend" id="aria-email" className="form-labels">
                    {t('ContactForm_General_Email_Label')}
                  </Form.Label>
                  <Form.Text className="muted helpText">
                    {t('ContactForm_General_Email_Help')}
                  </Form.Text>
                  <Form.Control
                    aria-labelledby="aria-email aria-email-warn"
                    ref={emailRef}
                    className={formErrors.email ? 'is-invalid' : ''}
                    onBlur={() => {
                      setValidateEmailOnChange(true);
                      validateFormFields();
                    }}
                    onChange={() => {
                      if (validateEmailOnChange) validateFormFields();
                      setRunMailCheck(true);
                    }}
                  />
                  {formErrors.email && (
                    <span className="errorMessage">{formErrors.email}</span>
                  )}
                  {showEmailConfirm && (
                    <div className="invalidEmailContainer">
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonYes')}
                        fill="outline"
                        className="mailCheckButton clickable-btn inactive-btn"
                        aria-label={t('Contact_EmailSuggestionYes').replace('xEmail', invalidEmailSuggestion)}
                        onClick={() => {
                          setRunMailCheck(false);
                          emailRef.current.value = invalidEmailSuggestion;
                          formErrors.email = null;
                          setInvalidEmailSuggestion(null);
                          setShowEmailConfirm(false);
                        }}
                      >
                        {t('Yes_Text')}
                      </Button>
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonNo')}
                        fill="outline"
                        className="mailCheckButton clickable-btn inactive-btn"
                        aria-label={t('Contact_EmailSuggestionNo')}
                        onClick={() => {
                          setShowEmailConfirm(false);
                          setRunMailCheck(false);
                          formErrors.email = null;
                        }}
                      >
                        {t('No_Text')}
                      </Button>
                    </div>
                  )}
                </fieldset>
              </Form.Group>

              <Form.Group
                className="form-inline"
                controlId="ContactForm_AppID_"
                required
              >
                <fieldset className="maple-radio">
                  <Form.Label id="app_label" as="legend" className={`form-labels ${formErrors.appId ? 'is-invalid' : ''}`}>
                    {t('ContactForm_General_AppID_Label')}
                  </Form.Label>
                  <div className="radio-container">
                    <RadioBuilder
                      value="Maple mobile app"
                      group="webmobile"
                      selected={mobileActive}
                      clickHandler={() => handleWebMobileClick('Maple mobile app')}
                      content={(
                        <>
                          <FontAwesomeIcon icon={faMobileAlt} className="btn-icon" />
                          {t('ContactForm_AppID_Mobile')}
                        </>
                      )}
                    />
                    <RadioBuilder
                      value="Maple website"
                      group="webmobile"
                      selected={webActive}
                      clickHandler={() => handleWebMobileClick('Maple website')}
                      content={(
                        <>
                          <FontAwesomeIcon icon={faWindow} className="btn-icon" />
                          {t('ContactForm_AppID_Website')}
                        </>
                      )}
                    />
                  </div>
                  {formErrors.appId && (
                    <span className="errorMessage errorMessageBlock ">{formErrors.appId}</span>
                  )}
                </fieldset>
              </Form.Group>

              {/* Which app did you use? */}
              <fieldset className="maple-radio form-group">
                <Form.Label id="category_label" as="legend" className="form-labels">
                  {t('ContactForm_General_Category_Label')}
                </Form.Label>

                <RadioBuilder
                  value="purchaseCard"
                  content={t('ContactForm_Category_Maple_PurchaseCard')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="activateCard"
                  content={t('ContactForm_Category_Maple_ActivateCard')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="pinIssues"
                  content={t('ContactForm_Category_Maple_PINIssues')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="lostStolenDamaged"
                  content={t('ContactForm_Category_Maple_LostStolenDamaged')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="linkIssues"
                  content={t('ContactForm_Category_Maple_LinkIssues')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="reloadIssues"
                  content={t('ContactForm_Category_Maple_ReloadIssues')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="useCard"
                  content={t('ContactForm_Category_Maple_UseCard')}
                  clickHandler={handleShowFields}
                />
                <RadioBuilder
                  value="accountDeletion"
                  content={t('ContactForm_Category_All_AccountDeletion')}
                  clickHandler={handleShowFields}
                  selected={removeAccount}
                />

                <Form.Text
                  id="category_error_message"
                  className="error-handling-messages"
                >
                  {t('Validation_Required')}
                </Form.Text>
              </fieldset>

              {showFields.pinIssues && (
                <RelevantFAQ
                  searchResults={hardcodedArticles?.pinIssues}
                  brand="canadapost-prepaid"
                  lang={lang}
                  isHardcoded
                  widgetMode={widgetMode}
                />
              )}
              {showFields.activateCard && (
                <RelevantFAQ
                  searchResults={hardcodedArticles?.activateCard}
                  brand="canadapost-prepaid"
                  lang={lang}
                  isHardcoded
                  widgetMode={widgetMode}
                />
              )}

              {showFields.linkIssues && (
                <fieldset className="linkIssues-fieldset">
                  <div id="fs-fullName">
                    <label
                      htmlFor="fullName"
                      className="form-labels"
                    >
                      {t('ContactForm_Maple_FullName_Label')}
                    </label>
                    <input
                      type="text"
                      ref={fullNameRef}
                      id="fullName"
                      className={`form-control ${formErrors.fullName ? 'is-invalid' : ''}`}
                      onBlur={() => setValidateFullNameOnChange(true)}
                      onChange={() => {
                        if (validateCardNumberOnChange) validateFormFields();
                      }}
                    />
                    {formErrors.fullName && (
                    <span className="errorMessage">{formErrors.fullName}</span>
                    )}
                  </div>
                  <div id="fs-cardNumber">
                    <label
                      htmlFor="cardNumber"
                      className="form-labels"
                    >
                      {t('ContactForm_Maple_CardNumber_Label')}
                    </label>
                    <input
                      type="text"
                      ref={cardNumberRef}
                      id="cardNumber"
                      className={`form-control ${formErrors.cardNumber ? 'is-invalid' : ''}`}
                      onBlur={() => setValidateCardNumberOnChange(true)}
                      onChange={() => {
                        if (validateCardNumberOnChange) validateFormFields();
                      }}
                      placeholder={t('ContactForm_Maple_CardNumber_Placeholder')}
                      maxLength={12}
                    />
                    {formErrors.cardNumber && (
                    <span className="errorMessage">{formErrors.cardNumber}</span>
                    )}
                    <button
                      type="button"
                      className="maple-showExampleCard-btn"
                      onClick={() => setShowExampleCard((prev) => !prev)}
                    >
                      {showExampleCard ? t('ContactForm_Maple_CardNumber_Button_Hide') : t('ContactForm_Maple_CardNumber_Button')}
                    </button>
                    {showExampleCard && (
                    <img
                      src={mapleCardExample}
                      alt={t('ContactForm_Maple_CardNumber_ImageDescription')}
                      className="maple-exampleCard-img"
                    />
                    )}
                  </div>
                </fieldset>
              )}

              {showFields.textArea && (
                <>
                  <Form.Group
                    className="form-groups"
                    controlId="ContactForm_General_Body_"
                    required
                  >
                    <fieldset>
                      <Form.Label as="legend" id="aria-desc" className="form-labels">
                        {t('ContactForm_General_Body_Label')}
                      </Form.Label>

                      <Form.Control
                        aria-labelledby="aria-desc"
                        as="textarea"
                        rows={8}
                        ref={bodyRef}
                        className={formErrors.description ? 'is-invalid' : ''}
                        onBlur={() => setValidateDescriptionOnChange(true)}
                        onChange={(e) => {
                          handleTextareaChange(e);
                          if (validateDescriptionOnChange) validateFormFields();
                        }}
                      />
                      {formErrors.description && (
                        <span className="errorMessage">{formErrors.description}</span>
                      )}
                    </fieldset>
                  </Form.Group>
                  <RelevantFAQ
                    searchResults={searchResults}
                    brand="canadapost-prepaid"
                    lang={lang}
                    widgetMode={widgetMode}
                  />
                </>
              )}

              {showFields.lostStolenDamaged && (
                <RelevantFAQ
                  searchResults={hardcodedArticles?.lostStolenDamaged}
                  brand="canadapost-prepaid"
                  lang={lang}
                  isHardcoded
                  widgetMode={widgetMode}
                />
              )}

              {showFields.transactionIssues && (
                <RelevantFAQ
                  searchResults={hardcodedArticles?.transactionIssues}
                  brand="canadapost-prepaid"
                  lang={lang}
                  isHardcoded
                  widgetMode={widgetMode}
                />
              )}

              {(showFields.textArea || showFields.linkIssues) && (
                <Button
                  id="submit-button"
                  className="maple-button"
                  type="submit"
                  disabled={disable}
                  size="lg"
                  style={{ backgroundColor: 'black !important' }}
                >
                  {t('ContactForm_Submit_button')}
                </Button>
              )}
            </Form>
            <Alert className="mt-3 email-banner" show={process.env.REACT_APP_ENV === 'dev'}>
              On the test system, contact form emails will be sent to
              <strong> psidevstar@gmail.com</strong>
            </Alert>
          </div>
        </div>
      )}
    </>
  );
}

export default translate(ContactUsMaple);
